<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Category"
      id="admin_view_category_category_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        :to="'/admin/categories/view/' + $route.params.id + '/edit'"
        small
        rounded
        class="mr-4"
        outlined
        color="warning"
      >
        <v-icon left>mdi-pen</v-icon>Edit Category
      </v-btn>
      <v-btn
        :to="'/admin/categories/view/' + $route.params.id + '/delete'"
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-times</v-icon> Remove Category
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="category.name"
        :icon="category.icon"
        :img_src="category.thumb_nail"
        :facts="view_header_facts"
        :description="category.description"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Sub Categories"
      id="admin_view_category_sub_categories"
    ></CardedSectionHeader>
    <CardedDisplay>
      <CardedTable
        :items="sub_categories"
        :headers="sub_category_headers"
        :show_description="true"
      >
        <template v-slot:actions>
          <v-btn
            :to="
              '/admin/categories/view/' + $route.params.id + '/add/subcategory'
            "
            small
            rounded
            class="ml-4"
            outlined
            color="success "
          >
            <v-icon left>mdi-plus</v-icon>Add Sub Category
          </v-btn>
        </template>
        <template v-slot:description>
          <p class="text-left ml-4 mr-4">
            This category has {{ sub_categories.length }} sub categories
          </p>
        </template>
        <template v-slot:[`item.icon`]="{ item }">
          <v-icon>{{ item.icon }}</v-icon>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="view_sub_category(item)"  x-small rounded text color="success">
            <v-icon>mdi-eye</v-icon> 
          </v-btn>
        </template> 
      </CardedTable>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Businesses In This Category"
      id="admin_view_category_businesses"
    ></CardedSectionHeader>
    <CardedDisplay>
      <CardedTable
        :items="businesses"
        :headers="business_headers"
        :show_description="true"
      >
        <template v-slot:[`item.owner`]="{ item }">
          {{ item.user.first_name }} {{ item.user.last_name }}
        </template>
        <template v-slot:[`item.sub_category`]="{ item }">
          <v-icon v-if="item.sub_category">{{item.sub_category.icon}}</v-icon> 
          {{(item.sub_category)? item.sub_category.name : ""}}
        </template>
        <template v-slot:description>
          <p class="text-left ml-4 mr-4">
            This category has {{ businesses.length }} businesses
          </p>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="view_business(item)"  x-small rounded text color="success">
            <v-icon>mdi-eye</v-icon> 
          </v-btn>
        </template> 
      </CardedTable>
    </CardedDisplay>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedTable from "../../../components/CardedTable";
import ViewHeader from "../../../components/ViewHeader";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminCategoriesView",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      id: 0,
      category: {
        id: 0,
        name: "",
        thumb_nail: "",
        description: "",
        is_top_category: 0,
        top_category_level: 0,
      },
      sub_categories: [],
      sub_categories_indexes: null,
      businesses: [],
      sub_category_headers: [
        {
          text: "Icon",
          align: "start",
          sortable: false,
          value: "icon",
          filterable: false,
        },
        { text: "Name", value: "name" },
        {
          text: "Businesses",
          value: "businesses",
          align: "center",
          filterable: false,
        },
        { text: "Description", value: "description", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      business_headers: [
        { text: "Name", value: "name" },
        { text: "Sub Category", value: "sub_category" },
        { text: "Phone Number", value: "office_phone_number1", sortable: false  },
        { text: "Owner", value: "owner", sortable: false  },
        { text: "Description", value: "description", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Top Category:",
          val: parseInt(this.category.is_top_category) == 1 ? "Yes" : "No",
        },
        { text: "Top Category Level:", val: this.category.top_category_level },
      ];
      return facts;
    },
  },
  mounted() {
    var category_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Category Details",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Categories",
          disabled: false,
          href: "/admin/categories",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/categories/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/admin/categories/view/" + category_id,
        },
      ],
    });
    this.$emit("on-show-loader");
    ServerClient.Categories.get_category(
      {
        id: category_id,
        is_admin: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.category = res.category;
        this.sub_categories_indexes = res.sub_categories_indexes;
        this.sub_categories = res.sub_categories;
        this.businesses = res.businesses;
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log("Errors while loading category details on admin", errors);
      }
    );
  },
  methods: {
    view_sub_category(sub_category) {
      this.$router.push("/admin/categories/sub_categories/view/" + sub_category.id);
    },
    view_business(business) {
      this.$router.push("/admin/businesses/view/" + business.id);
    },
  },
};
</script>

<style scoped>
.thumb_div {
  background-color: grey;
  height: 200px;
  width: 200px;
}

.view-title {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}

.view-label {
  /* font- */
}

.view-description-content {
  background-color: #cccccc24;
  height: 80px;
  border-radius: 10px;
  font-size: 16px;
  text-align: left;
  padding: 10px;
  color: #000000c7;
}
</style>